export function changed(this: any, primary: Record<string, any>, secondary: Record<string, any>, { expectSecondaryKey }: { expectSecondaryKey?: boolean } = { expectSecondaryKey: true }): boolean {
  let isChanged = false;
  if (expectSecondaryKey && typeof primary === "object" && typeof secondary !== "object") {
    return true;
  } else if (typeof primary !== "object" && typeof secondary === "object") {
    return true;
  }

  // throw new GemmaError("primary must be an ", { data: { source: primary, destination: secondary } });

  for (const key in primary) {
    if (isChanged) {
      break;
    }

    const sourceValue = primary[key];

    if (sourceValue === undefined || sourceValue === 0 || sourceValue === "" || sourceValue === false || sourceValue === null) {
      if (expectSecondaryKey && secondary[key] !== sourceValue) {
        return true;
      }
    } else if (typeof sourceValue.equals === "function") {
      const equals = sourceValue.equals(secondary[key]);
      if (!equals) {
        return true;
      }
    } else if (typeof sourceValue === "object") {
      if (expectSecondaryKey && !secondary[key]) {
        return true;
      }

      const _isChanged = changed.call(this, sourceValue, secondary[key], { expectSecondaryKey });
      if (_isChanged) {
        return true;
      }
    } else if (secondary[key] !== sourceValue) {
      return true;
    }
  }

  return isChanged;
}
